// Basic fixes and improvements for accessibility issues
$(document).ready(function () {
  $("h2").each(function() {
    if ($(this).html().trim() === "") {
        $(this).remove();
    }
    $('a[href^="tel"]').each(function () {
  var phoneText = $(this).text().trim();

  if (phoneText !== '') {
    $(this).attr('aria-label', 'Phone Number: ' + phoneText);
  }
});
});
    $('#AnnouncementSlider').removeAttr('tabindex');
    $('br').attr('aria-hidden','true');
    $('a[href="tel:+4803362144"]').attr('aria-label','Voice Number: (480) 336-2144');
    $('a[href="tel:+6029267900"]').attr('aria-label','Text Number: 602-926-7900');
    $('a[href="mailto:info@amishfurniturecreations.com"]').attr('aria-label','Email Address: info@amishfurniturecreations.com');
    $('a[href="/pages/amishfurniturecreations-com-accessibility-statement"]').attr('id','accessibility');
$('a').each(function () {
    // Check if the link is external
    if (this.hostname && this.hostname !== window.location.hostname && this.hostname !== 'www.amishfurniturecreations.com') {
      // Create a span element with warning text
      var warningSpan = $('<span class="u-visually-hidden">: This link will open in a new tab.</span>');
      // Set attributes for accessibility
      $(this).attr('target', '_blank').attr('rel', 'noopener noreferrer');
      // Append the warning span inside the link
      $(this).append(warningSpan);
    }
  });
$('[id^="Search"]').each(function() {
    var ids = $('[id="' + this.id + '"]');
    if (ids.length > 1) {
        ids.each(function(index) {
            $(this).attr('id', $(this).attr('id') + '_' + (index + 1));
        });
    }
});

$('[for^="Search"]').each(function() {
    var ids = $('[for="' + $(this).attr('for') + '"]');
    if (ids.length > 1) {
        ids.each(function(index) {
            $(this).attr('for', $(this).attr('for') + '_' + (index + 1));
        });
    }
});

$('[id^="gallery_view"]').each(function() {
  var ids = $('[id="' + this.id + '"]');
  if (ids.length > 1) {
      ids.each(function(index) {
          $(this).attr('id', $(this).attr('id') + '_' + (index + 1));
      });
  }
});
  $("button.modal__close").on("click", function () {
    setTimeout(function () {
      $(".new-grid").attr("tabindex", 0).focus();
    }, 1000);
  });
    $('span').each(function() {
        // Check if the span tag has the specific color
        if ($(this).css('color') === 'rgb(255, 0, 0)') { // red color in RGB format
            // Apply your desired style
            $(this).css('color', 'rgb(199, 0, 0)'); // Example: Change background color to yellow
        }
    });
    $('.collapsible-content__inner span').each(function() {
      // Check if the span tag has the specific color
      if ($(this).css('color') === 'rgb(255, 42, 0)') { // red color in RGB format
          // Apply your desired style
          $(this).css('color', 'rgb(199, 0, 0)'); // Example: Change background color to yellow
      }
  });
  $('.collapsible-content__inner span').each(function() {
    // Check if the span tag has the specific color
    if ($(this).css('color') === 'rgb(67, 191, 50)') { // red color in RGB format
        // Apply your desired style
        $(this).css('color', 'rgb(27, 85, 22)'); // Example: Change background color to yellow
    }
});
    $(".text-with-icons .text-with-icons__block").each(function() {
      var headingTitle = $(this).find(".text-with-icons__block-title h3").text();
      var linkTitle = $(this).find(".text-with-icons__block-text a").text();
      $(this).find(".text-with-icons__block-text a").attr("aria-label", linkTitle + " About " + headingTitle);
  });

});

// Mobile mavigation aria-expanded toggle
$(document).ready(function () {
  $('#MobileNavTriggers').on('click', function () {
    const isExpanded = $(this).attr('aria-expanded') === 'true';
    $(this).attr('aria-expanded', !isExpanded);
  });
});

// Drop down menu close on escape key press
$(document).on('keydown', function (e) {
  if (e.key === 'Escape' || e.keyCode === 27) {
    const $openDetails = $('details.site-nav__details[open]');

    $openDetails.each(function () {
      const $details = $(this);
      const $summary = $details.find('summary');

      // Remove open attribute
      $details.removeAttr('open');

      // Update aria-expanded
      $summary.attr('aria-expanded', 'false');

      // Return focus to summary for accessibility
      $summary.focus();
    });
  }
});



$(document).ready(function() {
    // By default, add a span tag inside 'active' class on page load
    $('.no-bullets button.grid-view-btn.is-active').attr('aria-expanded','true');
  
    // Click event for 'a' tag inside '.clickyboxes'
    $('.no-bullets button.grid-view-btn').on('click', function(event) {
      event.preventDefault(); // Prevent default behavior of link click
      
      // Remove 'active' class from all 'a' tags inside '.clickyboxes'
      $('.no-bullets button.grid-view-btn').removeClass('is-active').attr('aria-expanded','false');
      
      // Add 'active' class to the clicked 'a' tag
      $(this).addClass('is-active').attr('aria-expanded','true');
    });
  });
  document.addEventListener('DOMContentLoaded', function () {
    const accordionBtns = document.querySelectorAll(".accordion-header");
  
    accordionBtns.forEach((accordion) => {
      accordion.onclick = function () {
        const isOpen = this.classList.toggle("is-open");
  
        this.setAttribute('aria-expanded', isOpen);
        this.setAttribute('aria-selected', isOpen);
  
        let content = this.nextElementSibling;
  
        if (isOpen) {
          const maxHeight = window.innerWidth > 768 ? 300 : 150; // Adjust based on screen size
          content.style.maxHeight = Math.min(content.scrollHeight, maxHeight) + "px";
          content.setAttribute('aria-hidden', 'false');
        } else {
          content.style.maxHeight = null;
          content.setAttribute('aria-hidden', 'true');
        }
      };
    });
  });
  document.addEventListener('DOMContentLoaded', function() {
    var backToTopButton = document.getElementById('back-to-top');
  
    window.onscroll = function() {
        if (window.pageYOffset > 300) {
            backToTopButton.style.display = 'block';
        } else {
            backToTopButton.style.display = 'none';
        }
    };
  
    backToTopButton.onclick = function(e) {
        e.preventDefault();
        window.scrollTo({ top: 0, behavior: 'smooth' });
  
        // Set focus to the top of the page or the button itself after scrolling
        window.setTimeout(function() {
            document.getElementById('backtoheader').focus(); // If focusing the top element
            // backToTopButton.focus(); // If focusing the button itself
        }, 600); // Adjust the timeout duration to match the scroll duration
    };
  });
  var intervalID = window.setInterval(myCallback, 50);
  function myCallback() {
      var textAreaCheck = document.getElementsByClassName('g-recaptcha-response');
      if (textAreaCheck.length > 0) {
             jQuery(textAreaCheck).attr('aria-label', 'g-recaptcha-response');
             console.log(jQuery(textAreaCheck));
        clearInterval(intervalID);
      }
   }  